import {produce} from 'immer';
import {AnyAction} from 'redux';
import {
  GET_INCLUSIONS_SUCCESS,
  GET_INCLUSIONS_SUMMARY_SUCCESS,
  SET_INCLUSIONS_USER_SETTINGS
} from '../constants/inclusionConstants';


export interface IResponseStatus {
  message: string
  error: string
  data: any
  status: number
}
export interface IInclusionsSummary {
  read?: number
  toRead?: number
}

export interface IPatient {}

export interface IProthesis {
  prosthesis_reference: IProsthesisReference
}

export interface IProsthesisReference {
}

export interface IImplantation {
  patient: IPatient
  prosthesis: IProthesis
}

export interface IStoredFile {
  id: number
}

export interface IInclusions {
  id: string
  type: string
  implantation: IImplantation
  file: IStoredFile
  checked: boolean
}

export interface IUserSettings {
  activeTab: number
  activePage: number
  rowsPerPage: number
}

export interface IStateInclusions {
  inclusionsSummary: IInclusionsSummary,
  inclusions: IInclusions[]
  userSettings: IUserSettings
}

const initialState = {
  inclusionsSummary: {
    read: 0,
    toRead: 0
  },
  inclusions: [],
  userSettings: {
    activeTab: 0,
    activePage: 1,
    rowsPerPage: 100,
  }
} as IStateInclusions

const inclusionsReducers = produce((draft = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_INCLUSIONS_SUMMARY_SUCCESS:
      draft.inclusionsSummary = action.payload.data
      break
    case GET_INCLUSIONS_SUCCESS:
      draft.inclusions = action.payload.data
      break
    case SET_INCLUSIONS_USER_SETTINGS:
      draft.userSettings = action.userSettings
      break
    default:
      return draft
  }
})

export default inclusionsReducers
